(function () {
  "use strict";

  var e = {
    175: function _(e, r, t) {
      var n = this && this.__importDefault || function (e) {
        return e && e.__esModule ? e : {
          default: e
        };
      };

      Object.defineProperty(r, "__esModule", {
        value: !0
      }), r.validateExpiration = r.validateAddress = r.buildTransaction = r.ensureBlockFormat = r.normalizeTransactionObject = r.checksumEncode = r.numberToHex = r.hexToNumber = r.remove0x = r.ensure0x = r.gwei = r.toGwei = r.GWEI = void 0;
      var o = t(64),
          a = t(238),
          i = t(574),
          s = t(674),
          u = n(t(152)),
          c = 1e9;

      function d(e) {
        return e.startsWith("0x") ? e : "0x".concat(e);
      }

      function l(e) {
        return "string" == typeof e && e.startsWith("0x") ? e.slice(2) : e;
      }

      function f(e) {
        return parseInt(l(e), 16);
      }

      function m(e) {
        return d(new o.BigNumber(e).toString(16));
      }

      r.GWEI = c, r.gwei = function (e) {
        return new o.BigNumber(e).times(c);
      }, r.toGwei = function (e) {
        return new o.BigNumber(e).div(c);
      }, r.ensure0x = d, r.remove0x = l, r.hexToNumber = f, r.numberToHex = m, r.checksumEncode = function (e) {
        return u.default.encode(d(e));
      }, r.ensureBlockFormat = function (e) {
        return void 0 === e ? "latest" : d((0, a.padHexStart)(e.toString(16)));
      }, r.normalizeTransactionObject = function (e, r) {
        if ("object" != typeof e || null === e) throw new Error('Invalid transaction object: "'.concat(e, '"'));
        var t = {
          hash: l(e.hash),
          value: f(e.value),
          _raw: e
        };

        if (e.blockNumber && (t.blockNumber = f(e.blockNumber), t.blockHash = l(e.blockHash), r)) {
          var n = Math.max(r - t.blockNumber + 1, 0);
          t.confirmations = n;
        }

        if (e.gas && e.gasPrice) {
          var a = new o.BigNumber(e.gas),
              i = new o.BigNumber(e.gasPrice);
          t.fee = a.times(i).toNumber(), t.feePrice = i.div(c).toNumber();
        }

        return t;
      }, r.buildTransaction = function (e) {
        if (!e.to && ("string" != typeof e.data || 0 === e.data.length)) throw new Error("Sending to null with no data. Aborting.");
        var r = {
          from: d(e.from),
          value: e.value ? m(e.value) : "0x0"
        };
        return e.gasPrice && (r.gasPrice = d(e.gasPrice.times(c).dp(0, o.BigNumber.ROUND_CEIL).toString(16))), e.maxPriorityFeePerGas && (r.maxPriorityFeePerGas = d(e.maxPriorityFeePerGas.times(c).dp(0, o.BigNumber.ROUND_CEIL).toString(16))), e.maxFeePerGas && (r.maxFeePerGas = d(e.maxFeePerGas.times(c).dp(0, o.BigNumber.ROUND_CEIL).toString(16))), e.to && (r.to = d(e.to)), e.data && (r.data = d(e.data)), null !== e.nonce && void 0 !== e.nonce && (r.nonce = d(e.nonce.toString(16))), r;
      }, r.validateAddress = function (e) {
        var r = l((0, i.addressToString)(e));
        if ("string" != typeof r) throw new s.InvalidAddressError("Invalid address: ".concat(r));
        if (Buffer.from(r, "hex").toString("hex") !== r.toLowerCase()) throw new s.InvalidAddressError("Invalid address. Not hex: ".concat(r));
        if (20 !== Buffer.byteLength(r, "hex")) throw new s.InvalidAddressError("Invalid address: ".concat(r));
      }, r.validateExpiration = function (e) {
        (0, i.validateExpiration)(e);
        var r = e.toString(16),
            t = (0, a.padHexStart)(r, 5);
        if (Buffer.byteLength(t, "hex") > 5) throw new s.InvalidExpirationError("Invalid expiration: ".concat(e));
      };
    },
    238: function _(e) {
      e.exports = require("@yaswap/crypto");
    },
    674: function _(e) {
      e.exports = require("@yaswap/errors");
    },
    64: function _(e) {
      e.exports = require("@yaswap/types");
    },
    574: function _(e) {
      e.exports = require("@yaswap/utils");
    },
    152: function _(e) {
      e.exports = require("eip55");
    }
  },
      r = {},
      t = function t(n) {
    var o = r[n];
    if (void 0 !== o) return o.exports;
    var a = r[n] = {
      exports: {}
    };
    return e[n].call(a.exports, a, a.exports, t), a.exports;
  }(175);

  module.exports = t;
})();